export default {
    types:[
        'sine','square','triangle','sawtooth','pwm','pulse',
        'fmsine','fmsquare','fmtriangle','fmsawtooth',
        'amsine','amsquare','amtriangle','amsawtooth',
        'fatsine','fatsquare','fattriangle','fatsawtooth',
    ],
}
